import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RevisionOperacionODSService {



  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }
  
  getOperacionesByTechoId(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'opByTechoId/' + id, { headers: this.header(this.token) });
  }
  
  getListODS(): Observable<any> {
    return this.http.get(this.baseUrl + 'listODS', { headers: this.header(this.token) });
  }  

  getListPSDI(): Observable<any> {
    return this.http.get(this.baseUrl + 'listPSDI', { headers: this.header(this.token) });
  }
  
  postRevisionOperacionODS(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'postRevisionOperacionODS', bodyString, { headers: this.header(this.token) });
  }

  deleteRevisionOperacionODS(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'deleteRevisionOperacionODS/' + id, { headers: this.header(this.token) });
  }
}
